import type { TabsProps } from '@risk-smart/themed-cloudscape-components/tabs';
import { useTranslation } from 'react-i18next';
import type { useGetCustomRoleById } from 'src/hooks/queries/custom-role/useGetCustomRoleById';

import { filterEmptyTabs } from '@/utils/tabUtils';

import type { AvailableRole } from '../availableRoles';
import DetailsTab from './tabs/details/DetailsTab';

type GetCustomRoleByIdData = NonNullable<
  ReturnType<typeof useGetCustomRoleById>['data']
>;

export const useTabs = (
  customRole: GetCustomRoleByIdData['custom_role'][number] | undefined,
  availableRoles: AvailableRole[],
  parentPath: string
): TabsProps['tabs'] => {
  const { t } = useTranslation(['common'], { keyPrefix: 'customRoles' });
  const tabs = [
    {
      label: t('tabs.details'),
      id: 'details',
      href: `${parentPath}/details`,
      content: customRole && (
        <DetailsTab customRole={customRole} availableRoles={availableRoles} />
      ),
    },
  ];

  return filterEmptyTabs(tabs);
};
